/** Resizes an image in the browser (max 1920 px, WebP) so screens never download huge photos. */
export async function prepareImage(file: File, maxSide = 1920): Promise<Blob> {
  if (!/^image\/(png|jpe?g|webp|gif)$/.test(file.type)) throw new Error('Choose a PNG, JPEG, WebP or GIF image.');
  if (file.size > 25 * 1024 * 1024) throw new Error('That image is over 25 MB. Choose a smaller one.');
  if (file.type === 'image/gif') return file;
  const bmp = await createImageBitmap(file);
  const s = Math.min(1, maxSide / Math.max(bmp.width, bmp.height));
  const w = Math.round(bmp.width * s), h = Math.round(bmp.height * s);
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  c.getContext('2d')!.drawImage(bmp, 0, 0, w, h);
  bmp.close();
  return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('Couldn’t process that image.'))), 'image/webp', 0.86));
}
